import { Component, EventEmitter, inject, Output, signal } from '@angular/core';
import { RouterModule, Router, NavigationEnd } from '@angular/router';
import { Footer } from '../footer/footer';
import { Header } from '../header/header';
import { filter } from 'rxjs/operators';
import { RiberaLoaderUi } from '@ribera-web/ribera-loader-ui'
import { SpinnerLoadingService } from '@ribera-web/http-loading';
import { DashboardTabs } from '@ribera-web/dashboard-ui';
import { CommonModule } from '@angular/common';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { SidebarClient } from '../sidebar-client/sidebar-client';
import { PromotersProfileUi} from '@ribera-web/promoters-dashboard-ui';

@Component({
  selector: 'lib-shell',
  imports: [RouterModule, Header, CommonModule, Footer, RiberaLoaderUi, DashboardTabs, SidebarClient, PromotersProfileUi],
  templateUrl: './shell.html',
  styleUrl: './shell.scss',
})
export class Shell {
  private router = inject(Router);
  spinner = inject(SpinnerLoadingService);

  public isDashboardRoute = signal<boolean>(true);
  public isMemberEventsRoute = signal<boolean>(false);
  loading = true;

  private readonly DEFAULT_TOKEN =
    'eyJhbGciOiJIUzM4NCJ9.eyJzdWIiOiJZQTQwNjYxMjY4Iiwicm9sZXMiOlt7ImF1dGhvcml0eSI6IjEifV0sImlkIjo3NTcsInN0YXRlIjoiQUNUSVZFIiwiaWF0IjoxNzYyMjkyOTU0LCJleHAiOjE3NjIyOTY1NTR9.LaBt-Ay5UQW1MBJhme0igZ9GKDLsMf-83eQN_enpsKCCig0QAOalftCRpwgrDqaB';

  isCollapsed = signal(false);

  get isLoggedIn(): boolean {
    const token = localStorage.getItem('accessToken');
    return !!token && token !== this.DEFAULT_TOKEN;
  }

  constructor() {
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => {
        setTimeout(() => {
          window.scrollTo(0, 0);
          document.documentElement.scrollTop = 0;
          document.body.scrollTop = 0;
        }, 0);
      });

    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd),
      takeUntilDestroyed()
    ).subscribe(() => {
      this.checkIfIsDashboard();
    });
    this.checkIfIsDashboard();
  }

  toggleSidebar(event: boolean) {
    this.isCollapsed.set(event);
  }

  private checkIfIsDashboard() {
    const currentPath = this.router.url.split('?')[0];
    this.isMemberEventsRoute.set(
      currentPath === '/events' || currentPath.startsWith('/events/')
    );

    const segments = currentPath.split('/').filter(s => s !== '');
    const lastSegment = segments.pop() || '';

    const dashboardPaths = [
      'dashboard',
      'data',
    ];
  
    this.isDashboardRoute.set(dashboardPaths.some(path => lastSegment.includes(path)));
  }
}
